import actions from './actions'

const initialState = {
  user: {},
  role: '',
  token: '',
  authorized: false,
  loading: false,
  accountsCheck: [],
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
